import { useMutation } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { ArticleRequest } from '../../api/queries';

export enum CreateArticleCacheKey {
  CreateArticle = 'CreateArticle',
}

export const useCreateArticleWithDraftMutation = () => {
  const { createArticleWithDraft } = useServicesContext();
  return useMutation({
    mutationKey: [CreateArticleCacheKey.CreateArticle],
    mutationFn: ({ article }: { article: Partial<ArticleRequest> }) =>
      createArticleWithDraft({ article }),
  });
};
